
import SyncLoader from "vue-spinner/src/SyncLoader.vue";

export default {
    name: "Loader",
    components: {
        SyncLoader
    },
    props: {
        size: {
            type: String,
            default: "15px"
        }
    },
    data() {
        return {
            color: "var(--primary)"
        };
    }
};
